import { ProductBlock } from './ProductBlock';

export function ProductSingleValue(props) {
  const { image, label } = props.data;

  return <ProductBlock image={image} label={label} />;
}
